import { actions } from '@grandvisionhq/state';

const FETCH_ADDRESSES = 'auth/addresses/fetch-list';
const FETCH_ADDRESSES_SUCCESS = 'auth/addresses/fetch-list-success';
const FETCH_ADDRESSES_FAILED = 'auth/addresses/fetch-list-failed';
const TOGGLE_MODAL = 'auth/adresses/toggle_modal';
const ADD_ADDRESS = 'auth/addresses/add-address';
const ADD_ADDRESS_SUCCESS = 'auth/addresses/add-address-success';
const ADD_ADDRESS_FAILED = 'auth/addresses/add-address-failed';
const EDIT_ADDRESS = 'auth/addresses/edit-address';
const EDIT_ADDRESS_SAVE = 'auth/addresses/edit-address-save';
const EDIT_ADDRESS_SUCCESS = 'auth/addresses/edit-address-success';
const EDIT_ADDRESS_FAILED = 'auth/addresses/edit-address-failed';
const DELETE_ADDRESS = 'auth/addresses/delete-address';
const DELETE_ADDRESS_CONFIRM = 'auth/addresses/add-address-confirm';
const DELETE_ADDRESS_SUCCESS = 'auth/addresses/delete-address-success';
const DELETE_ADDRESS_FAILED = 'auth/addresses/delete-address-failed';
const { action , payload  } = actions;
/**
 * Fetch list
 */ const fetchList = action(FETCH_ADDRESSES);
const fetchListSuccess = action(FETCH_ADDRESSES_SUCCESS, payload());
const fetchListFailed = action(FETCH_ADDRESSES_FAILED, (error)=>({
        error
    })
);
/**
 * ToggleModal
 */ const toggleModal = action(TOGGLE_MODAL, payload());
/**
 * Add address
 */ const addAddress = action(ADD_ADDRESS, payload());
const addAddressSuccess = action(ADD_ADDRESS_SUCCESS, payload());
const addAddressFailed = action(ADD_ADDRESS_FAILED, (error)=>({
        error
    })
);
/**
 * Delete address
 */ const deleteAddress = action(DELETE_ADDRESS, payload());
const deleteAddressConfirm = action(DELETE_ADDRESS_CONFIRM);
const deleteAddressSuccess = action(DELETE_ADDRESS_SUCCESS, payload());
const deleteAddressFailed = action(DELETE_ADDRESS_FAILED, (error, id)=>({
        error,
        id
    })
);
/**
 * Edit address
 */ const editAddress = action(EDIT_ADDRESS, payload());
const editAddressSave = action(EDIT_ADDRESS_SAVE, payload());
const editAddressSuccess = action(EDIT_ADDRESS_SUCCESS, payload());
const editAddressFailed = action(EDIT_ADDRESS_FAILED, (error)=>({
        error
    })
);

export { ADD_ADDRESS, ADD_ADDRESS_FAILED, ADD_ADDRESS_SUCCESS, DELETE_ADDRESS, DELETE_ADDRESS_CONFIRM, DELETE_ADDRESS_FAILED, DELETE_ADDRESS_SUCCESS, EDIT_ADDRESS, EDIT_ADDRESS_FAILED, EDIT_ADDRESS_SAVE, EDIT_ADDRESS_SUCCESS, FETCH_ADDRESSES, FETCH_ADDRESSES_FAILED, FETCH_ADDRESSES_SUCCESS, TOGGLE_MODAL, addAddress, addAddressFailed, addAddressSuccess, deleteAddress, deleteAddressConfirm, deleteAddressFailed, deleteAddressSuccess, editAddress, editAddressFailed, editAddressSave, editAddressSuccess, fetchList, fetchListFailed, fetchListSuccess, toggleModal };
//# sourceMappingURL=actions.js.map
